export const LENS_NAME_VALIDATION_MESSAGES = {
    SPECIAL_CHARS: 'Special characters are not allowed. Please enter a valid lens name.',
    DUPLICATE: 'This custom lens name already exist, please use a different name.',
    MAX_LENGTH: 'Only 20 characters are allowed.',
} as const;

export const CREATE_LENS_TOOLTIP_MESSAGES = {
    ADD_DIMENSION: 'Add Dimension to Create Lens',
    ADD_KPI: 'Add KPI to Create Lens',
} as const;

export const DISABLED_ITEMS_MESSAGES = {
    UNDER_DIMENSION: 'Disabled items are already selected under Dimension.',
    UNDER_KPI: 'Disabled items are already selected under User Inputs/KPIs.',
} as const;

export const getCustomLensLimitReachedMessage = (limit: number) =>
    `You have reached the maximum limit of ${limit} custom lenses. Delete an existing lens to create a new one.`;
